export { default, Detached } from './SalesTab';
